import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent {
  username = '';
  password = '';
  error = '';
  isLoading = false;

  constructor(
    private authService: AuthService,
    private router: Router
  ) { }

  onSubmit() {
    this.isLoading = true;
    this.error = '';

    this.authService.login(this.username, this.password).subscribe(
      success => {
        this.isLoading = false;
        if (success) {
          this.router.navigate(['/sandbox']);
        } else {
          this.error = 'Invalid username or password';
        }
      },
      error => {
        this.isLoading = false;
        this.error = 'An error occurred during login';
      }
    );
  }
} 
